import { YStack } from 'tamagui';

import { BodyMediumRegular, BodySmallRegular } from '../text/Typography';

interface SelectSingleItemProps {
    title: string;
    description?: string;
    disabled?: boolean;
    selected?: boolean;
    onPress: () => void;
}

const SelectSingleItem = ({
    title,
    description,
    disabled = false,
    selected = false,
    onPress,
}: SelectSingleItemProps) => {
    return (
        <YStack
            alignItems="center"
            justifyContent="center"
            gap={4}
            padding={8}
            minHeight={64}
            maxWidth={480}
            borderWidth={2}
            borderRadius={16}
            borderColor={
                disabled ? '$gray200' : selected ? '$black' : '$gray200'
            }
            backgroundColor={disabled ? '$gray100' : '$white'}
            hoverStyle={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                borderColor: disabled
                    ? '$gray200'
                    : selected
                      ? '$black'
                      : '$gray300',
            }}
            pressStyle={{
                scale: disabled ? 1 : 0.99,
                borderColor: disabled ? '$gray200' : '$black',
            }}
            animation="button"
            animateOnly={['borderColor', 'transform']}
            onPress={disabled ? () => {} : onPress}
            opacity={disabled ? 0.6 : 1}
        >
            <BodyMediumRegular
                color={disabled ? '$gray1000' : selected ? '$black' : '$black'}
                textAlign="center"
            >
                {title}
            </BodyMediumRegular>
            {description != null && (
                <BodySmallRegular color="$gray1000" textAlign="center">
                    {description}
                </BodySmallRegular>
            )}
        </YStack>
    );
};

interface SelectSingleProps {
    options: Array<{
        title: string;
        description?: string;
        disabled?: boolean;
    }>;
    selectedIndex?: number | null;
    onSelect: (index: number) => void;
}

export const SelectSingle = ({
    options,
    selectedIndex,
    onSelect,
}: SelectSingleProps) => {
    return (
        <YStack gap={12}>
            {options.map((option, index) => (
                <SelectSingleItem
                    key={index}
                    title={option.title}
                    description={option.description}
                    disabled={option.disabled}
                    selected={selectedIndex === index}
                    onPress={() => {
                        onSelect(index);
                    }}
                />
            ))}
        </YStack>
    );
};
